import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { EASINGS, SCENE } from '../../lib/motion';
import { IS_PRERENDER } from '../../lib/prerender';

export default function PageTransition() {
    const prefersReducedMotion = useReducedMotion();

    if (prefersReducedMotion || IS_PRERENDER) return null;

    return (
        <motion.div
            className="pointer-events-none fixed inset-0 z-[90]"
            aria-hidden="true"
            initial={{ y: '0%' }}
            animate={{ y: '-100%' }}
            transition={{ duration: 0.7, ease: EASINGS.smooth, delay: 0.15 }}
        >
            <div className="h-full w-full bg-gradient-to-br from-indigo-600 via-[#0F172A] to-[#090D16]" />
            <div className="absolute inset-0 flex items-center justify-center">
                <motion.span
                    className="font-sora font-extrabold text-white/90 text-xl tracking-tight"
                    initial={{ opacity: 1 }}
                    animate={{ opacity: 0, y: -12 }}
                    transition={{ duration: SCENE, ease: EASINGS.smooth, delay: 0.05 }}
                >
                    Jerwin<span className="text-indigo-400">.dev</span>
                </motion.span>
            </div>
        </motion.div>
    );
}